import React, { useState, useEffect } from 'react';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useLocation } from "react-router-dom";

import Section from '../Section';
import { getArchivContentData } from '../../server/ServerFunc';
import SvgIcon from '../../CustomeComponents/SvgIcon';

const ArchivPikuahInfo = ({ isSeparate }) => {
    const [archivDocsList, setArchivDocsList] = useState([]);
    const [isDocExtension, setIsDocExtension] = useState(false);
    const [extensionMessage, setExtensionMessage] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const [systemCode, setSystemCode] = useState("");
  
    const titles = {
        "documentDate": "תאריך תיוק",
        "documentDescr": "שם המסמך",
        "urlDoc": "צרופות"
    }
  
    const search = useLocation().search;
    
    useEffect(() => {
      const tikNumURL = new URLSearchParams(search).get("TikNum");
      const systemCodeURL = new URLSearchParams(search).get("SystemCode");
      getArchivContent(systemCodeURL, tikNumURL);
      setIsMobile(window.innerWidth < 768);
      setSystemCode(systemCodeURL);
    }, []);
    
  
    const getArchivContent = async (systemCode, tikNum) => {
      const archivData = await getArchivContentData(systemCode, tikNum);
      if(archivData.length > 0) {
        let isDocExtensionDwfx = false;
        for (let i = 0; i < archivData.length; i++) {
          if(archivData[i].docExtension === 'dwfx') {
            isDocExtensionDwfx = true;
            break;
          }
        }
  
        setIsDocExtension(isDocExtensionDwfx);
        setExtensionMessage(<div><b>לצפייה בקבצי DWFX יש להתקין תוכנה חינמית <a href='https://www.autodesk.com/products/design-review/download'>Design Review</a></b></div>)
        setArchivDocsList(archivData);
      } else {
        setArchivDocsList([]);
      }
    }
  
    const openDocUrl = (docUrl) => {
      window.open(`${docUrl}`,"_blank");
    }
    
    const LabeledDataItem = (label, value) => {
          return <div className="labeled-grid-cell">
              <div className="label">{label}</div>
              <div className="value">{value}</div>
          </div>
      }
  
    const LabeledCell = (props) => {
          return <td {...props.tdProps}>
              {LabeledDataItem(titles[props.field], props.dataItem[props.field])}
          </td>
      }
  
    const SvgIconCell = (props) => {
      const data = props.dataItem;
          return <td {...props.tdProps} className="icon-cell">
              {LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => openDocUrl(data.urlDoc)} />)}
          </td>
      }
  
    const ArchivTable = () => {
      return (
          <Grid data={archivDocsList} >
              <GridColumn field="documentDate" title={titles.documentDate} cell={LabeledCell} />
              <GridColumn field="documentDescr" title={titles.documentDescr} cell={LabeledCell} />
              <GridColumn field="urlDoc" title={titles.urlDoc} cell={SvgIconCell} headerClassName={'icon-header-cell'} />
            </Grid>
        )
    }
  
    return (
      <>
        {/* { isSeparate && <AppHeaderGlobal /> } */}
        {
        //   systemCode === "26400046" ?
        //     <div style={{ margin: (!isSeparate ? "-104px 0px 0px 0px" : ""), backgroundColor: "white" }} >
        //       <div className="container my-3 my-lg-5">
        //         <Section icon={'hammer'} title={'ארכיב אופטי'} className="mt-3" >
        //           {
        //             archivDocsList.length > 0 ?
        //               <>
        //                 {
        //                   isDocExtension ?
        //                     <div>{extensionMessage}</div>
        //                     :
        //                     ""
        //                 }
        //                 <ArchivTable />
        //               </>
        //               :
        //               <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
        //           }
        //         </Section>
        //       </div>
        //     </div>
        //     :
            <div className="container my-3 my-lg-5">
              <Section icon={'hammer'} title={'ארכיב אופטי'} className="mt-3" >
                {
                  archivDocsList.length > 0 ?
                    <>
                      {
                        isDocExtension ?
                          <div>{extensionMessage}</div>
                          :
                          ""
                      }
                      <ArchivTable />
                    </>
                    :
                    <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                }
              </Section>
            </div>
        }
        {/* { isSeparate && <AppFooter /> } */}
      </>
    )
}

export default ArchivPikuahInfo